import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as api from '../../shared/api/apihandler';
import { CaseDetails } from 'app/shared-html-components/details/details.component';
import { BoschDataList } from './bosch-contract-data';

@Component({
  selector: 'app-bosch-contracts',
  templateUrl: './bosch-contracts.component.html',
  styleUrls: ['./bosch-contracts.component.css']
})
export class BoschContractsComponent implements OnInit, OnChanges {
  @Input() offerId;
  @Input() chaId;
  @Input() case: CaseDetails;
  reportData = new Report();
  assetServiceAgreementChoice;
  approveStatus = false;
  data = new BoschDataList();
  isLocked = false;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes)
    if (changes.chaId && !!changes.chaId.currentValue && !!this.case) {
      this.getChaDocument(changes.chaId.currentValue);
    }
    //console.log(this.case);
    if (!!this.case.offerList.find(x => x.offerId == this.offerId).offerPdfId) {
      this.isLocked = true;
    }
  }

  getChaDocument(id) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get(api.jubloApi + 'api/Website/Offer/GetChaDocument/' + id, { headers }).subscribe(
      (data: Json) => {
        if (!!data && !!data.json) {
          let x = JSON.parse(data.json);
          if (!!x && !!x.reportData) {
            this.reportData = x.reportData;
            //console.log(this.reportData);
          }
        } else {
          this.reportData.customer.address = this.case.customer.address;
          this.reportData.customer.zipCode = this.case.customer.zipCode;
          this.reportData.customer.city = this.case.customer.city;
          this.reportData.customer.email = this.case.customer.email;
          this.reportData.customer.phone = this.case.customer.phone;
          this.reportData.customer.name = this.case.customer.name;
          this.reportData.assetAddress = this.case.customer.address;
          this.reportData.assetCity = this.case.customer.city;
          this.reportData.assetZipCode = this.case.customer.zipCode;
        }
      },
      (err) => { 
        console.log(err);
      },
      () => {
        this.getCaseProperties();
      }
    )
  }

  getCaseProperties() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get(api.jubloApi + 'api/Website/Case/GetCaseProperties/' + this.case.caseId, { headers }).subscribe(
      (data: any) => {
        //console.log(data);
        if (!!data && data.length > 0) {
          let d = data.find(x => x.propertyId == 'ad120766-7881-4824-855a-ef38171efde1')?.value;
          if (!!d) {
            let specialDoc = JSON.parse(d).Value[0];
            console.log(specialDoc);
            this.reportData.assetType = !!this.reportData.assetType ? this.reportData.assetType : specialDoc.assetType;
            this.reportData.assetModel = !!this.reportData.assetModel ? this.reportData.assetModel : specialDoc.assetModel;
            this.reportData.assetModelInside = !!this.reportData.assetModelInside ? this.reportData.assetModelInside : specialDoc.assetModelInside;
            this.reportData.assetSerialNumberOutside = !!this.reportData.assetSerialNumberOutside ? this.reportData.assetSerialNumberOutside : specialDoc.assetSerialNumberOutside;
            this.reportData.assetSerialNumberInside = !!this.reportData.assetSerialNumberInside ? this.reportData.assetSerialNumberInside : specialDoc.assetSerialNumberInside;
            console.log(this.reportData);
          }
        }
      },
      (err) => { 
        console.log(err);
      },
      () => {
        this.saveDoc();
      }
    )
  }

  saveDoc() {
    let date = new Date().toISOString();
    let data = JSON.stringify({
      date: date,
      version: 1,
      reportData: this.reportData
    });
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/Website/Offer/UpdateChaDocument/' + this.chaId + '/' + this.approveStatus,
      {
        "Json": data
      }, { headers }).subscribe(
        (val) => {
          //console.log(val);
        },
        (response) => {
          console.log('Error!', response);
        },
        () => {
          //console.log('done saving');
        });
  }
}

export class Report {
  assetAddress: string = '';
  assetZipCode: string = '';
  assetCity: string = '';
  customer = new Customer;
  assetType: string = '';
  assetModel: string = '';
  assetModelInside: string = '';
  assetSerialNumberInside: string = '';
  assetSerialNumberOutside: string = '';
  assetServiceAgreementType: string = 'Basis';
  assetServiceAgreement: string = '';
  assetInstaller: string = '';
  assetStartDate: string = '';
  assetHybrid: string = '';
  assetRemarks: string = '';
}

export class Customer {
  name: string = '';
  address: string = '';
  zipCode: string = '';
  city: string = '';
  email: string = '';
  phone: string = '';
}

class Json {
  json: string;
}